
const BlogDetailsImage = ({ image }) => {
  return (
    <div className="py-6 px-4 md:px-10 w-full flex justify-center">
      <img
        src={image}
        alt="Blog"
        className="w-full max-w-4xl h-auto rounded-lg shadow-md object-cover"
      />
    </div>
  );
};

export default BlogDetailsImage;
